import React from "react";
import { useForm } from "react-hook-form";
import backend from "../../../api";
import { useHistory } from "react-router-dom";
import { Notification } from "../../../utils";

export default function VACForm() {
  const { handleSubmit, register, errors, getValues } = useForm();
  const history = useHistory();

  const submitForm = async () => {
    const val = getValues();
    if (val) {
      const status = new Notification();
      try {
        const { data } = await backend.post("/consentform", val);
        status.set_toast("success", data.message);
        status.show_toast();
        history.push(`${process.env.PUBLIC_URL}/consent-form/${data.data._id}`);
      } catch (error) {
        status.set_toast(
          "error",
          error.response ? error.response.data.message : error.message
        );
      }
    }
  };
  return (
    <div>
      <section className="about-page  section-b-space">
        <div className="container ">
          <div className="row">
            <div className="col-lg-12 ">
              <strong>
                <p className="text-center">
                  Parlay Roial, LLC <br /> PARENTAL CONSENT FORM
                  <br /> FOR ENTRY IN EKSPLODE™ VIDEO AD CONTEST <br />
                  BY A MINOR
                </p>
              </strong>
              <br />
              <div className="form-row">
                <h5>Name of Contest Entrant: </h5>
                <div className="col-6 ml-3">
                  <input
                    type="text"
                    className="form-control ml-1"
                    id="name"
                    name="entrant_name"
                    placeholder="Entrant Name"
                    ref={register({
                      required: {
                        value: true,
                        message: "This Field is Required",
                      },
                    })}
                  />
                  <label htmlFor="name" className="error">
                    {errors.entrant_name && errors.entrant_name.message}
                  </label>
                </div>
              </div>
              <div className="form-row">
                <h5>Email of Contest Entrant: </h5>
                <div className="col-6 ml-4">
                  <input
                    type="text"
                    className="form-control"
                    id="E_email"
                    name="entrant_email"
                    placeholder="Email"
                    ref={register({
                      required: {
                        value: true,
                        message: "This Field is Required",
                      },
                      pattern: {
                        value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                        message: "This must be a valid Email",
                      },
                    })}
                  />
                  <label htmlFor="E_email" className="error">
                    {errors.entrant_email && errors.entrant_email.message}
                  </label>
                </div>
              </div>

              <div className="form-row">
                <h5>Birthdate of Entrant: </h5>
                <div className="col-6 ml-5">
                  <input
                    type="date"
                    className="form-control ml-2"
                    id="dob"
                    name="entrant_DOB"
                    placeholder="Entrant Date of birth"
                    ref={register({
                      required: {
                        value: true,
                        message: "This Field is Required",
                      },
                    })}
                  />
                  <label htmlFor="dob" className="error ml-2">
                    {errors.entrant_DOB && errors.entrant_DOB.message}
                  </label>
                </div>
              </div>

              <div className="form-row">
                <h5>Name of Parent/Guardian: </h5>
                <div className="col-6 ml-3">
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    name="guardian_name"
                    placeholder="Parent/Guardian Name"
                    ref={register({
                      required: {
                        value: true,
                        message: "This Field is Required",
                      },
                    })}
                  />
                  <label htmlFor="name" className="error">
                    {errors.guardian_name && errors.guardian_name.message}
                  </label>
                </div>
              </div>

              <div className="form-row">
                <h5>Email address of Parent: </h5>
                <div className="col-6 ml-4">
                  <input
                    type="text"
                    className="form-control ml-2"
                    id="G_email"
                    name="guardian_email"
                    placeholder="Email"
                    ref={register({
                      required: {
                        value: true,
                        message: "This Field is Required",
                      },
                      pattern: {
                        value: /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/,
                        message: "This must be a valid Email",
                      },
                    })}
                  />
                  <label htmlFor="G_email" className="error ml-2">
                    {errors.guardian_email && errors.guardian_email.message}
                  </label>
                </div>
              </div>

              <p>
                <strong>Verification of Consent:</strong>
                In order to permit the entrant identified above (referred to as
                “Entrant”) to enter the Eksplode™ Video Ad Contest (VAC), the
                parent or legal guardian identified above (referred to as
                “Parent”) must print out, sign and date this Parental Consent
                Form and send a scanned copy to Parlay Roial at the following
                email address: ____________________.
              </p>
              <p>
                <small>
                  By signing and dating this Parental Consent Form where
                  indicated below, the parent or legal guardian (“Parent”) of
                  the contest entrant named above (“Entrant”) hereby
                  acknowledges and agrees as follows.
                </small>
              </p>

              <ol className="text-left">
                <li>
                  <p>
                    <small>
                      <strong>1. Age of Entrant.</strong>
                      The Entrant is 13 years of age or older but under the age
                      of 18.
                    </small>
                  </p>
                </li>
                <br />
                <li>
                  <p>
                    <small>
                      <strong>2. Authority of Parent.</strong>
                      The Parent is the parent or legal guardian of the Entrant.
                    </small>
                  </p>
                </li>
                <li>
                  <p>
                    <small>
                      <strong>3. Authorization.</strong>
                      Parent authorizes the Entrant to enter the VAC according
                      to the Official Rules and the Terms of Use and Privacy
                      Policy as posted at Parlay Roial’s website.
                    </small>
                  </p>
                </li>
                <li>
                  <p>
                    <small>
                      <strong>4. Consent.</strong>
                      Parent consents to the collection of personal data from
                      the Entrant, and the use of the Entrant’s personal data by
                      Parlay Roial, all subject to the Contest Rules, the Terms
                      of Use and the Privacy Policy posted at the contest
                      website.
                    </small>
                  </p>
                </li>
                <li>
                  <p>
                    <small>
                      <strong>5. Ratification by Parent.</strong>
                      The undersigned Parent, on behalf herself or himself and
                      on behalf of the Entrant, hereby acknowledges and agrees
                      as follows:
                      <ol>
                        <li>
                          (a) Parent has read and understood and hereby ratifies
                          and approves the Contest Rules, the Terms of Use and
                          the Privacy Policy.{" "}
                        </li>
                      </ol>
                      <ol>
                        <li>
                          (b) The Parent is the parent or legal guardian of the
                          Entrant.
                        </li>
                      </ol>
                      <ol>
                        <li>
                          (c)Parent shall generally cooperate with Parlay Roial
                          in order to give full force and effect to this
                          Parental Consent. By way of example, if requested by
                          Parlay Roial, Parent will cooperate with Publisher in
                          obtaining court approval of this Parental Consent Form
                          as provided for under applicable law.
                        </li>
                      </ol>
                      <ol>
                        <li>
                          (d) Entrant and Parent acknowledge and agree that
                          Parlay Roial intends and is entitled to rely on this
                          Parental Consent Form and would not have accepted an
                          entry from the Entrant if the Parental Consent Form
                          had not been signed and returned.
                        </li>
                      </ol>
                    </small>
                  </p>
                </li>
              </ol>
              <div className="row">
                <div className="col">
                  <p>
                    <small>Agreed and confirmed:</small>
                  </p>
                </div>
                <div className="col">
                  {/* <strong> <hr style={{height:"1px",border:none",color:"#333",}}/></strong> */}
                  <br />
                  <hr />
                  <p>Parent</p>
                  <br />
                  <br />
                  <strong>
                    {" "}
                    <hr />
                  </strong>
                  <p>Date</p>
                </div>
              </div>
            </div>
          </div>
          <br />

          <div className="form-row">
            <a
              href="#"
              className="btn btn-solid ml-3"
              onClick={handleSubmit(submitForm)}
            >
              Submit
            </a>
            {/* <Link className="btn btn-light d-flex align-items-center" to="/login">
          Already filled form?
        </Link> */}
          </div>
        </div>
      </section>
    </div>
  );
}
